import { Check } from "lucide-react";
import VatInfoTooltip from "../ui/VatInfoTooltip";

const KarbantartasSection = () => {
  const features = [
    "A weboldal folyamatosan elérhető",
    "Alap technikai ellenőrzés és karbantartás",
    "Ha elakadsz, segítünk"
  ];

  return (
    <section id="karbantartas" data-testid="karbantartas-section" className="light-band py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text text-center">
            Karbantartás és egyebek —{" "}
            <span className="text-primary">ne ezzel foglalkozz</span>
          </h2>

          <p className="scroll-animate mt-6 text-muted-text text-base sm:text-lg text-center max-w-2xl mx-auto">
            Ha szeretnéd, a weboldal futtatását és alap karbantartását mi intézzük, hogy neked ezzel ne legyen dolgod. Te csak használod.
          </p>

          {/* Subscription tiles */}
          <div className="scroll-animate-stagger scroll-animate mt-12 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-3xl p-8 border border-primary/10">
              <h3 className="font-sora font-bold text-xl text-ink-text">Futtatás + alap karbantartás</h3>
              <div className="mt-3 flex items-baseline">
                <span className="text-2xl font-bold text-ink-text">9 000</span>
                <span className="text-lg text-muted-text ml-2">Ft / év</span>
                <VatInfoTooltip />
              </div>

              <div className="mt-6 space-y-3">
                {features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <Check size={18} className="text-accent flex-shrink-0" />
                    <span className="text-ink-text/80">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 rounded-xl bg-white/60 text-sm text-muted-text">
                <p>Domain vásárlásban és beállításban segítünk — ingyen.</p>
                <p className="mt-2">Ha nem szeretnél saját domaint, futhat a mi aldomainünkön is — ingyen.</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-accent/5 to-primary/5 rounded-3xl p-8 border border-accent/10">
              <h3 className="font-sora font-bold text-xl text-ink-text">Prémium támogatás</h3>
              <div className="mt-3 flex items-baseline">
                <span className="text-2xl font-bold text-ink-text">47 000</span>
                <span className="text-lg text-muted-text ml-2">Ft / év</span>
                <VatInfoTooltip />
              </div>

              <div className="mt-6 space-y-3">
                <div className="flex items-center gap-3">
                  <Check size={18} className="text-accent flex-shrink-0" />
                  <span className="text-ink-text/80">Minden az alap csomagból</span>
                </div>
                <div className="flex items-center gap-3">
                  <Check size={18} className="text-accent flex-shrink-0" />
                  <span className="text-ink-text/80">Prioritásos támogatás</span>
                </div>
                <div className="flex items-center gap-3">
                  <Check size={18} className="text-accent flex-shrink-0" />
                  <span className="text-ink-text/80">Havi 1 kisebb módosítás</span>
                </div>
                <div className="flex items-center gap-3">
                  <Check size={18} className="text-accent flex-shrink-0" />
                  <span className="text-ink-text/80">Teljesítmény optimalizálás</span>
                </div>
              </div>

              <div className="mt-6 p-4 rounded-xl bg-white/60 text-sm text-muted-text">
                <p>Ideális ha folyamatos fejlesztést szeretnél.</p>
                <p className="mt-2">Nyugodt háttér, profi kiszolgálás.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KarbantartasSection;
